<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1">
        <div class="mb-2" style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold label="จัดการบทบาท" />
          </v-flex>
          <v-btn
            variant="outlined"
            icon
            :color="'#BECCDB'"
            style="border-radius: 50% !important"
            @click="showAdminModalAdd = true"
          >
            <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
          </v-btn>
        </div>
        <v-layout class="my-5" justify-center v-if="loading">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-layout>
        <v-data-table
          v-else
          expand
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="groups"
          class="elevation-1"
          item-key="name"
        >
          <template v-slot:items="props">
            <td>{{ props.item.groupname || '-' }}</td>
            <td>{{ props.item.groupdescription || '-' }}</td>
            <td>
              <div
                class="pointer"
                style="text-decoration: underline; color: #26588b"
                @click="showDetail(props.item)"
              >
                ดูรายละเอียด
              </div>
            </td>
            <td style="white-space: nowrap">
              <TooltipTable
                :datas="props"
                @modalEdit="showEdit(props), (showAdminModalEdit = true)"
                @Delete="deleteGroup(props.item)"
                :showDelete="props.item.user_count > 0 ? false : true"
              ></TooltipTable>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <!-- <v-flex xs12 :sm6="selectedGroup" class="pa-1" v-if="selectedGroup">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="grey--text mt-2">{{ selectedGroup.groupname }} Group</h2>
          </v-flex>
          <add-admin-sub-group
            :group="selectedGroup"
            @addSubGroup="addSubGroup"
          ></add-admin-sub-group>
        </v-layout>

        <template v-if="filterSubGroups && filterSubGroups.length > 0">
          <v-card>
            <template v-for="(subgroup, gindex) in filterSubGroups">
              <div class="pa-3" :key="`group_${subgroup.id}`">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ subgroup.subgroupname }}
                    </div>
                    <div class="caption">
                      {{ subgroup.subgroupdescription ? subgroup.subgroupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-sub-group
                    :group="selectedGroup"
                    v-model="filterSubGroups[gindex]"
                    @editSubGroup="editSubGroup"
                  ></edit-admin-sub-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteSubGroup(subgroup)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </v-layout>
              </div>
              <v-divider
                :key="`group_divider_${subgroup.id}`"
                v-if="filterSubGroups.length - 1 != gindex"
              />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex> -->
    </v-layout>

    <!-- <div class="pa-1 mt-4">
      <v-layout class="mb-2">
        <v-flex>
          <h2 class="title grey--text mt-2">Admin Users</h2>
        </v-flex>
        <add-user :projectdata="projectdata" @addUser="onAddUser"></add-user>
      </v-layout>
      <v-layout class="my-5" justify-center v-if="allusersloading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        :loading="allusersloading"
        :headers="headers"
        :pagination.sync="pagination"
        :items="admins"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <template v-if="props.item.type == 'admin'">
              <change-password :userid="props.item.adminid"></change-password>
            </template>
          </td>
          <td>{{ getRole(props.item.privilege) || '-' }}</td>
          <td>{{ props.item.groupname || '-' }}</td>
          <td>{{ props.item.subgroupname || '-' }}</td>
          <td>
            <template v-if="!loadingAgentGroup && !loadingAgentSubGroup">
              <edit-user
                :key="props.index + '_' + props.item.adminid"
                v-model="props.item"
                :projectdata="projectdata"
                @editUser="onEditUser"
              ></edit-user>
            </template>
            <v-btn
              fab
              small
              outline
              color="primary"
              @click="onDeleteUser(props.item)"
              :disabled="admins.length <= 1"
              ><v-icon>delete</v-icon></v-btn
            >

          </td>
        </template>
      </v-data-table>
    </div> -->
    <v-dialog v-model="showDetailModal" persistent width="500px">
      <v-card style="border-radius: 10px">
        <div class="pa-4">
          <div style="display: flex; justify-content: space-between">
            <Typography h2 bold label="สิทธิ์การเข้าถึง" />
            <v-icon style="display: flex; align-items: center" @click="showDetailModal = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2 pl-3" style="display: flex">
                <div style="white-space: nowrap; width: 40%">
                  <Typography h5 semiBold color="color-black" label="ชื่อกลุ่ม :" />
                  <Typography h5 semiBold color="color-black" label="รายละเอียด :" />
                  <Typography h5 semiBold color="color-black" label="เปลี่ยนสถานะจ่ายเงิน :" />
                  <Typography h5 semiBold color="color-black" label="เพิ่มสมาชิกเข้าโครงการ :" />
                  <Typography h5 semiBold color="color-black" label="เพิ่มสมาชิกเดิมเข้าโครงการ :" />
                  <Typography h5 semiBold color="color-black" label="เมนูที่สามารถเข้าถึง :" />
                </div>
                <div style="width: 60%" class="form-control">
                  <Typography h5 medium color="color-black" :label="inputDetail.groupname || '-'" />
                  <Typography
                    h5
                    medium
                    color="color-black"
                    :label="inputDetail.groupdescription || '-'"
                  />
                  <Typography
                    h5
                    medium
                    color="color-black"
                    :label="inputDetail.can_change_payment_status ? 'มีสิทธิ์' : 'ไม่มีสิทธิ์'"
                  />
                  <Typography
                    h5
                    medium
                    color="color-black"
                    :label="inputDetail.can_add_member_project ? 'มีสิทธิ์' : 'ไม่มีสิทธิ์'"
                  />
                  <Typography
                    h5
                    medium
                    color="color-black"
                    :label="inputDetail.can_add_same_member_project ? 'มีสิทธิ์' : 'ไม่มีสิทธิ์'"
                  />
                  <div v-for="item in inputDetail.privilege" :key="item.key" sub-group>
                    <template v-if="item.checked">
                      <Typography h5 color="color-black" :label="$t(item.meta.title)" />
                    </template>
                    <div v-for="children in item.children" :key="children.key" class="pl-2">
                      <div v-if="children.checked" style="display: flex">
                        <span class="pr-1">- </span>
                        <Typography h5 color="color-black" :label="$t(children.meta.title)" />
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showAdminModalAdd" max-width="500">
      <add-admin-group
        v-if="showAdminModalAdd"
        @addGroup="addGroup"
        @closemodal="showAdminModalAdd = false"
      ></add-admin-group>
    </v-dialog>

    <v-dialog persistent v-model="showAdminModalEdit" max-width="500">
      <edit-admin-group
        v-if="showAdminModalEdit"
        v-model="groups[showEditItem.index]"
        @editGroup="editGroup"
        :key="showEditItem.index"
        @closemodal="showAdminModalEdit = false"
        @edit="getAdminGroup"
      ></edit-admin-group>
      <!-- <v-btn
        fab
        small
        outline
        color="primary"
        @click="onDeleteUser(props.item)"
        :disabled="admins.length <= 1"
        ><v-icon>delete</v-icon></v-btn
      > -->
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
const AddAdminGroup = () => import('./AddAdminGroup')
const EditAdminGroup = () => import('./EditAdminGroup')
const AddAdminSubGroup = () => import('./AddAdminSubGroup')
const EditAdminSubGroup = () => import('./EditAdminSubGroup')
const ChangePassword = () => import('./ChangePassword')
const AddUser = () => import('./AddUser')
const EditUser = () => import('./EditUser')
import { ToggleButton } from 'vue-js-toggle-button'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Typography from '@/components/elements/Typography.vue'

import { parse } from 'date-fns'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
    }),
    filterSubGroups() {
      if (this.selectedGroup) {
        return this.subgroups.filter((el) => {
          return el.admingroupid == this.selectedGroup.id
        })
      }
      return []
    },
  },
  components: {
    AddAdminGroup,
    EditAdminGroup,
    AddAdminSubGroup,
    EditAdminSubGroup,
    ChangePassword,
    AddUser,
    EditUser,
    ToggleButton,
    TooltipTable,
    Typography,
  },
  data() {
    return {
      showAdminModalAdd: false,
      showAdminModalEdit: false,
      showDetailModal: false,
      projectdata: null,
      showEditItem: {},
      loading: false,
      adminloading: [],
      admins: [],
      inputDetail: {},
      groups: [],
      subgroups: [],
      pagination: {
        rowsPerPage: 999,
      },
      headers: [
        { text: 'ชื่อกลุ่ม', sortable: false },
        { text: 'รายละเอียด', sortable: false },
        { text: 'สิทธิ์การเข้าถึง', sortable: false },
        { text: '', sortable: false },
      ],
      selectedGroup: null,
    }
  },
  async mounted() {
    this.loading = true
    try {
      await this.getAdminGroup()
      // var responseSubGroup = await this.getAdminSubGroup()
      // var responseAdmin = await this.getAdmins()
      // this.projectdata = await this.getProject()
      // if (responseGroup.data) {
      //   this.groups = responseGroup.data
      // }
      // if (responseSubGroup.data) {
      //   this.subgroups = responseSubGroup.data
      // }
      // // if (responseAdmin.data) {
      //   this.admins = responseAdmin.data
      // }
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    // getProject() {
    //   return new Promise((resolve) => {
    //     api.getdepaproject({}, (err, response) => {
    //       if (response.responsecode == 200) {
    //         resolve(response.data)
    //       } else {
    //         resolve(null)
    //       }
    //     })
    //   })
    // },
    getRole(privilege) {
      try {
        var parsed_privilege = JSON.parse(privilege)
        if (parsed_privilege.role == 'agency') {
          return 'หน่วยร่วม'
        } else if (parsed_privilege.role == 'admin') {
          return 'Admin'
        } else if (parsed_privilege.role == 'superadmin') {
          return 'Super admin'
        } else return ''
      } catch (error) {
        return ''
      }
    },
    showEdit(props) {
      this.showEditItem = props
    },
    putassignstatusByadminid(adminid, status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        assign_status: !status,
        adminid: adminid,
      }
      this.adminloading.push(adminid)
      api.putassignstatusByadminid(data, (err, response) => {
        if (response.responsecode == 200) {
          var index = vm.adminloading.findIndex((el) => el == adminid)
          vm.adminloading.splice(index, 1)
          status = !status
        }
      })
    },
    async showDetail(item) {
      this.inputDetail = item
      this.showDetailModal = true
    },
    // async onAddUser(user) {
    //   this.$store.dispatch('loadAgents')
    //   var responseAdmin = await this.getAdmins()
    //   if (responseAdmin.data) {
    //     this.admins = responseAdmin.data
    //   }
    //   this.$swal.fire({
    //     type: 'success',
    //     text: 'เพิ่มแอดมินสำเร็จ',
    //   })
    // },
    // async onEditUser(user) {
    //   this.$store.dispatch('loadAgents')
    //   var responseAdmin = await this.getAdmins()
    //   if (responseAdmin.data) {
    //     this.admins = responseAdmin.data
    //   }
    // },
    // getAdmins() {
    //   var data = {
    //     pageid: this.selectedBot.pageid,
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdmins(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    getAdminGroup() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          this.groups = response.data
          resolve()
          // resolve(response)
          this.loading = false
        })
      })
    },
    // getAdminSubGroup() {
    //   var data = {
    //     pageid: this.selectedBot.pageid,
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdminSubGroup(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    addGroup(payload) {
      this.groups.push(payload)
      this.$store.dispatch('loadAgentGroups')
    },
    async editGroup(payload) {
      var index = this.groups.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.groups, index, payload)
      }
      this.$store.dispatch('loadAgentGroups')
    },
    // async onDeleteGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.groupname.replace(/\<|\>/g, ''),
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true,
    //   })
    //   if (result.value) {
    //     await this.deleteGroup(group)
    //     var index = this.groups.findIndex((el) => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.groups.splice(index, 1)
    //       this.$store.dispatch('loadAgentGroups')
    //     }
    //   }
    // },
    deleteGroup(data) {
      let { id } = data
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ยืนยันการลบกลุ่มหรือไม่</div>',
          html: '<div class="primary--text fs-16">*หากยืนยันกลุ่มจะถูกลบออกและไม่สามารถกู้คืนได้</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then(async (result) => {
          if (result.value) {
            api.deleteadmingroup({ id: id, pageid: 'DEPA' }, async (err, response) => {
              if (err) {
                console.error(err)
                reject(err)
              }
              var responseGroup = await this.getAdminGroup()
              this.groups = responseGroup.data
              this.$swal.fire({
                title: '<div class="headline primary--text bold7 fs-24">ลบกลุ่มสำเร็จ</div>',
                showCancelButton: false,
                showCloseButton: true,
              })
            })
          }
        })
    },
    // addSubGroup(payload) {
    //   this.subgroups.push(payload)
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // editSubGroup(payload) {
    //   var index = this.subgroups.findIndex((el) => {
    //     return el.id == payload.id
    //   })
    //   if (index != -1) {
    //     this.$set(this.subgroups, index, payload)
    //   }
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // async onDeleteSubGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.subgroupname.replace(/\<|\>/g, ''),
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true,
    //   })
    //   if (result.value) {
    //     await this.deleteSubGroup(group)
    //     var index = this.subgroups.findIndex((el) => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.subgroups.splice(index, 1)
    //       this.$store.dispatch('loadAgentSubGroups')
    //     }
    //   }
    // },
    // deleteGroup(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       id: data.id,
    //       pageid: this.selectedBot.pageid,
    //     }
    //     api.deleteadminsubgroup(request, function (error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // async onDeleteUser(user) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: user.name.replace(/\<|\>/g, ''),
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true,
    //   })
    //   if (result.value) {
    //     this.$store.dispatch('loading')
    //     await this.deleteadminusers({ userid: user.adminid })
    //     if (this.$store.state.userid == user.adminid) {
    //       this.$store.dispatch('logout', null).then()
    //       if (this.user.type == 'admin') {
    //         this.$router.push('/' + this.currentLang + '/nigol')
    //       } else {
    //         this.$router.push('/' + this.currentLang + '/login')
    //       }
    //     }
    //     var responseAdmin = await this.getAdmins()
    //     if (responseAdmin.data) {
    //       this.admins = responseAdmin.data
    //     }
    //     this.$store.dispatch('loading')
    //   }
    // },
    // deleteadminusers(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       userid: data.userid,
    //       pageid: this.selectedBot.pageid,
    //     }
    //     api.deleteadminusers(request, function (error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/UsersGroup.vue